/**
 * 將 URL 中的數字 id 收斂成 /{id}，讓 Sentry 能依「路由樣板」聚合錯誤，
 * 而非被每個不同 id 拆成數百筆獨立 issue。
 * 例：https://api.example.com/users/123/files/456 -> /users/{id}/files/{id}
 */
export const getGeneralizedPath = (url: string): string => {
  try {
    const urlObj = new URL(url);
    return urlObj.pathname.replace(/\/\d+/g, '/{id}');
  } catch (error) {
    console.error('[sentry] Invalid URL:', error);
    return url;
  }
};
